import { AppService } from "app/services/app.service";
import { ConfigPortas } from "app/models/configportas.model";
import { Observable } from "rxjs";

export abstract class AbConfigPortas extends AppService {
  abstract prefixo: string;
  abstract getConfigPortas(): Observable<any>;
  abstract getConfigPortasHub(): Observable<any>;
  abstract getConfigPortasPromise();
  abstract carregarPortas(configPortas: ConfigPortas): Observable<any>;
  abstract saveConfigPortas(configPortas: ConfigPortas): Observable<any>;
}